import { render } from "./FAT.vue?vue&type=template&id=0f5fe366&scoped=true"
import script from "./FAT.vue?vue&type=script&lang=js"
export * from "./FAT.vue?vue&type=script&lang=js"

import "./FAT.vue?vue&type=style&index=0&id=0f5fe366&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5fe366"]])

export default __exports__